import { z } from "zod";

import { i18n } from "@libs/i18n";
import { publicStaffRoleEnumSchema } from "@libs/schemas";

export const signInSchema = z.object({
  email: z.string().email(i18n.t("main:login.errors.invalidEmail")).min(1),
});

export const verificationCodeSchema = z.object({
  code: z.string().length(6, i18n.t("main:login.errors.invalidCode")),
});

export type SignInFormDataType = z.infer<typeof signInSchema>;
export type VerificationCodeFormDataType = z.infer<
  typeof verificationCodeSchema
>;

export const authSearchParamsSchema = z.object({
  redirect: z
    .string()
    .optional()
    .transform(v => {
      if (!v) return "";
      if (v.includes("http")) {
        try {
          const url = new URL(v);
          return v.replace(`${url.protocol}//${url.host}`, "");
        } catch {
          return "";
        }
      }
      return v;
    })
    .catch(""),
});

export type AuthSearchParamsType = z.infer<typeof authSearchParamsSchema>;

export type UserType = "STAFF" | "STUDENT";
export type UserRoleType =
  | z.infer<typeof publicStaffRoleEnumSchema>
  | "STUDENT";
